import { render, staticRenderFns } from "./GeneralBarChartComponent.vue?vue&type=template&id=65b43995&"
import script from "./GeneralBarChartComponent.vue?vue&type=script&lang=js&"
export * from "./GeneralBarChartComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports